namespace TabAurous.Inventory {
    export namespace OpeningStockService {
        export const baseUrl = 'OpeningStock/OpeningStock';

        export declare function Create(request: Serenity.SaveRequest<OpeningStockRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OpeningStockRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OpeningStockRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<OpeningStockRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetLineNo(request: Serenity.ServiceRequest, onSuccess?: (response: GetLineNoResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OpeningStock/OpeningStock/Create",
            Update = "OpeningStock/OpeningStock/Update",
            Delete = "OpeningStock/OpeningStock/Delete",
            Retrieve = "OpeningStock/OpeningStock/Retrieve",
            List = "OpeningStock/OpeningStock/List",
            GetLineNo = "OpeningStock/OpeningStock/GetLineNo"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetLineNo'
        ].forEach(x => {
            (<any>OpeningStockService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
